/**
 * Picklist services
 */

export default class ApiPicklist {
    constructor($http, $rootScope, Restangular, ApiBaseResponseService, GenericMethods) {
        return {
            getContinents() {
                return Restangular
                    .one('picklists')
                    .get({ picklistObject: 'PRODUCT', picklistReference: 'PRODUCT_REGION' })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getRegions() {
                return Restangular
                    .one('picklists')
                    .get({ picklistObject: 'PRODUCT', picklistReference: 'PRODUCT_SUBREGION' })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getAccountCountries() {
                return Restangular
                    .one('picklists')
                    .get({ picklistObject: 'ACCOUNT', picklistReference: 'ACCOUNT_BILLING_COUNTRY' })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getAccountStates() {
                return Restangular
                    .one('picklists')
                    .get({ picklistObject: 'ACCOUNT', picklistReference: 'ACCOUNT_BILLING_STATE' })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getContactCountries() {
                return Restangular
                    .one('picklists')
                    .get({ picklistObject: 'CONTACT', picklistReference: 'CONTACT_MAILING_COUNTRY' })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getContactStates() {
                return Restangular
                    .one('picklists')
                    .get({ picklistObject: 'CONTACT', picklistReference: 'CONTACT_MAILING_STATE' })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getCountries() {
                return GenericMethods.retrieveLocalFile('data/', 'cc.json');
            },

            getAdvindaCountries() {
                return GenericMethods.retrieveLocalFile('data/', 'advindaCountryList.json');
            },

            getInvestorTypes() {
                return GenericMethods.retrieveLocalFile('data/', 'investorTypes.json');
            },

            retrieveLevelsOfInterest() {
                return GenericMethods.retrieveLocalFile('data/', 'levelsOfInterest.json');
            },

            retrieveAssetClasses() {
                return GenericMethods.retrieveLocalFile('data/', 'assetClasses.json');
            },

            getEuropeanUnionCountries() {
                return GenericMethods.retrieveLocalFile('data/', 'europeanUnionList.json');
            },

            getCurrencies() {
                return GenericMethods.retrieveLocalFile('data/', 'currencies.json');
            },

            // creates Picklist number / date values
            createPicker(startValue, range) {
                var array = [];
                for (var i = startValue; i < startValue + range; i++) {
                    array.push(i);
                }

                return array;
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/services/apiPicklist.js
 **/